import { useContent } from "../content/ContentContext";

export const Marquee = () => {
  const { SITE } = useContent();
  const ITEMS = SITE.marquee;

  return (
    <div
      className="relative border-y border-white/10 bg-coal/60 py-5 overflow-hidden"
      data-testid="editorial-marquee"
    >
      <div className="flex w-max animate-marquee">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex items-center shrink-0" aria-hidden={dup === 1}>
            {ITEMS.map((item, i) => (
              <span key={`${dup}-${i}`} className="flex items-center">
                <span className="font-display text-sm md:text-base tracking-[0.34em] text-ivory/50 whitespace-nowrap px-8">
                  {item}
                </span>
                <span className="text-gold/60 text-[9px]">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
